module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAwCAYAAABuZUjcAAAAtElEQVRoge3aMQoCMRRF0ZsQGffgbgQX4WJdhbVYa6HtgNFYiBv4gRcC70LKD6d4zcCky1r3wMJcPQvwfzNVMtBGKwK1PFoQzXB1hqszXJ3h6gxXZ7g6w9UZrq7rk223ycee+wr32+tzitx2wZecuuClcQZC8GmnYri6ro2/fxuN39Ou0dt0WesB2PYABvSYdiqGqzNcneHqDFdnuDrD1RmuznB1hqvLQBqNCJQKUJnv74n6BQ8OGybOodKcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/menos.png
// module id = 787
// module chunks = 0